//
// Copyright 2024 DXOS.org
//

import React, { useEffect, useState } from 'react';

import { ConnectionState } from '@dxos/protocols/buf/dxos/client/services_pb';
import { useNetworkStatus } from '@dxos/react-client/mesh';
import * as Icon from '@dxos/react-ui/Icon';
import { mx } from '@dxos/ui-theme';

import { styles } from './styles.ts';

/**
 * Swarm connection handler.
 */
// TODO(burdon): Add network toggle.
export const NetworkIndicator = () => {
  const [state, setState] = useState(0);
  const { swarm } = useNetworkStatus();
  useEffect(() => {
    setState(swarm === ConnectionState.ONLINE ? 0 : 1);
  }, [swarm]);

  if (state === 0) {
    return (
      <span title='Connected to swarm.'>
        <Icon.Icon icon='ph--lightning--regular' />
      </span>
    );
  } else {
    return (
      <span title='Disconnected from swarm.'>
        <Icon.Icon icon='ph--lightning-slash--regular' classNames={mx(styles.warning)} />
      </span>
    );
  }
};
